import React from 'react';
import { XCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function PainPoints() {
  const points = ['Noches sin dormir pensando qué decirle mañana para que no se cierre más', 'Caminando sobre cáscaras de huevo para no generar otra explosión', 'Siempre los mismos sermones porque no sabés qué más intentar', 'La ansiedad, el encierro, la baja autoestima sin saber por dónde empezar', 'Grupos de WhatsApp de padres donde nadie tiene la solución real', 'Fin de semana agotado, el lunes el ciclo vuelve a empezar igual'];
  return <section className="py-12 relative overflow-hidden" data-id="element-183">
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-184">
        <FadeIn data-id="element-185">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-6" data-id="element-186">
            ¿Cuántas noches más vas a quedarte{' '}
            <span className="text-red-500" data-id="element-187">sin dormir pensando qué hacer?</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-188">
          <p className="text-lg md:text-xl text-gray-300 text-center mb-8 leading-relaxed" data-id="element-189">
            Sos un padre o una madre que ama profundamente a su hijo/a. Pero
            nadie te dijo que la adolescencia iba a sentirse tan parecida a
            perderlo/a.
            <br data-id="element-190" />
            <br data-id="element-191" />
            <strong className="text-white" data-id="element-192">
              No es falta de amor. Es falta de herramientas.
            </strong>
          </p>
        </FadeIn>

        <div className="bg-surface p-8 md:p-10 rounded-3xl border border-red-500/20 shadow-[0_0_30px_rgba(239,68,68,0.05)]" data-id="element-193">
          <ul className="space-y-6" data-id="element-194">
            {points.map((point, index) => <FadeIn key={index} delay={0.2 + index * 0.1} data-id="element-195">
                <li className="flex items-start gap-4" data-id="element-196">
                  <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-197" />
                  <span className="text-lg text-gray-300" data-id="element-198">{point}</span>
                </li>
              </FadeIn>)}
          </ul>
        </div>

        <FadeIn delay={0.8} data-id="element-199">
          <div className="mt-8 text-center" data-id="element-200">
            <p className="text-2xl md:text-3xl font-heading text-gold" data-id="element-201">
              ¿Y si esta fuera la última noche que pasás sin saber qué hacer?
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}